import { FC, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { trackEvent } from "~/utils/analytics";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmitted: () => void;
};

export const PipedriveFormModal: FC<Props> = ({
  isOpen,
  onClose,
  onSubmitted,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://webforms.pipedrive.com") return;

      if (event.data && event.data.type === "pd_webform_success") {
        setIsSubmitted(true);
        trackEvent({ eventName: "pipedrive_form_submitted" });
        onSubmitted();
      }
    };

    if (isOpen) {
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    }
  }, [isOpen, onSubmitted]);

  useEffect(() => {
    if (isOpen) {
      const script = document.createElement("script");
      script.src = "https://webforms.pipedrive.com/f/loader";
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      trackEvent({ eventName: "pipedrive_modal_viewed" });
    }
  }, [isOpen]);

  const handleClose = () => {
    trackEvent({
      eventName: "pipedrive_modal_closed",
      properties: { submitted: isSubmitted },
    });
    onClose();
  };

  const formUrl =
    "https://webforms.pipedrive.com/f/czEugGd84gqvI6uwLXG9uqSG0O3QhBwyrkw5K2NZBV733LBX1Ax8yPTnuZafHb3NMn?V2ViRm9ybUNhcHR1cmVCbG9jazpmMzQyNzRhMC01YzE2LTExZjAtYjc2Mi1jM2RjOTIyMmU5Y2M=Petya";

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-h-[98vh] flex flex-col overflow-hidden">
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>
            <FormattedMessage
              id="pipedriveModal.title"
              defaultMessage="While You Wait..."
            />
          </DialogTitle>
          <DialogDescription>
            <FormattedMessage
              id="pipedriveModal.description"
              defaultMessage="Help us improve our service by sharing your feedback while your documents are being processed."
            />
          </DialogDescription>
        </DialogHeader>
        <div className="flex-grow overflow-y-auto">
          <div
            className="pipedriveWebForms h-full"
            data-pd-webforms={formUrl}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
